module.exports = __webpack_public_path__ + "img/logo_fubon.4dc540ac.svg";